import React, { useState } from 'react'
import { AiOutlineHome, AiOutlineUser } from "react-icons/ai";
import { BiBook, BiMessageSquareDetail } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import "./nav.css";
const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={() => { setActiveNav("#") }} className={activeNav === '#' ? 'active' : ''}><AiOutlineHome /></a>
      <a href="#about" onClick={() => { setActiveNav("#about") }} className={activeNav === '#about' ? 'active' : ''}><AiOutlineUser /></a>
      <a href="#experince" onClick={() => { setActiveNav("#experince") }} className={activeNav === '#experince' ? 'active' : ''}><BiBook /></a>
      <a href="#services" onClick={() => { setActiveNav("#services") }} className={activeNav === '#services' ? 'active' : ''}><RiServiceLine /></a>
      <a href="#contact" onClick={() => { setActiveNav("#contact") }} className={activeNav === '#contact' ? 'active' : ''}><BiMessageSquareDetail /></a>
    </nav>
  )
}

export default Nav